import React, { useState } from "react";
import TextAnimP1 from "../components/TextAnimP1";
import TextAnimH1 from "../components/TextAnimH1";
import { Link } from "react-router-dom";
import gsap from "gsap";
import TextAnimation from "../components/TextAnimation";

export default function HomeServicesVerticalSection() {
  const caseStudyData = [
    {
      id: 1,
      image: "/new-final-data/home/Graphic.webp",
      category: "/Services",
      title: "PPC",
      description:
        "Creatives Solutions  |  Motion Design  |  Illustration Design  |  Print...",
      href: "/marketing?service=4",
      position: "top-[-5%]",
    },
    {
      id: 2,
      image: "/new-final-data/home/Branding.webp",
      category: "/Services",
      title: "Branding",
      description:
        "Logo Design  |  Brand Strategy  |  Visual Identity  |  Brand Guidelines  |  Na...",
      href: "/design?service=12",
      position: "top-[10%]",
    },
    {
      id: 3,
      image: "/new-final-data/home/WebnDigital.webp",
      category: "/Services",
      title: "Web Design",
      description:
        "Website Design | Website Development | UI/UX Design | Ecommerce Sol...",
      href: "/technology?service=1",
      position: "top-[30%]",
    },
    {
      id: 4,
      image: "/new-final-data/home/WebnDigital.webp",
      category: "/Services",
      title: "Performance",
      description:
        "Website Design | Website Development | UI/UX Design | Ecommerce Sol...",
      href: "/marketing",
      position: "top-[30%]",
    },
    {
      id: 5,
      image: "/new-final-data/home/DIgitalM.webp",
      category: "/Services",
      title: "Marketing",
      description:
        "Logo Design | Brand Identity | Marketing Materials | Brand Strategy...",
      href: "/marketing",
      position: "top-[45%]",
    },
    {
      id: 6,
      image: "/new-final-data/home/Content.webp",
      category: "/Services",
      title: "Content",
      description:
        "3D Modelling  |  Content Strategy  |  Copywriting  |  Photography   |  Anim...",
      href: "/marketing?service=7",
      position: "top-[62%]",
    },
    {
      id: 7,
      image: "/new-final-data/home/Content.webp",
      category: "/Services",
      title: "UI Design",
      description:
        "3D Modelling  |  Content Strategy  |  Copywriting  |  Photography   |  Anim...",
      href: "/design?service=1",
      position: "top-[62%]",
    },
    {
      id: 8,
      image: "/new-final-data/home/Production.webp",
      category: "/Services",
      title: "UX Writing",
      description:
        "Creative Direction & Storyboarding  |  Scriptwriting & Copywriting  |  Cam...",
      href: "/design?service=11",
      position: "top-[78%]",
    },
  ];

  const [lineX, setLineX] = useState(0);

  return (
    <div className="min-h-screen text-white pt-40 overflow-hidden pointer-events-auto">
      <div className="mx-auto relative z-30 px-10 xl:px-35">
        {/* Content */}
        <div
          onMouseMove={(e) => {
            const container = e.currentTarget;
            const { left, width } = container.getBoundingClientRect();
            const mouseX = e.clientX - left;
            const percent = Math.max(0, Math.min(100, (mouseX / width) * 100));
            setLineX(percent);
          }}
          className="w-full home-services-effect relative z-30 flex flex-col xl:flex-row xl:h-[80vh] gap-4 xl:gap-0"
        >
          {caseStudyData.map((section, index) => (
            <React.Fragment key={section.id}>
              <Link
                to={section.href}
                className="xl:w-1/8 xl:h-full flex relative group xl:py-0"
              >

                <div className="xl:ml-55 flex-1 xl:rotate-[-90deg] w-full">
                  <h2
                    style={{
                      WebkitTextStroke: "1px #71717b",
                      fontSize: 'clamp(24px, 4vw + 2vh, 85px)',
                    }}
                    className="dark:text-white text-black font-semibold xl:w-[50vw] group-hover:text-transparent transition-colors duration-300 flex gap-3 xl:gap-6 items-center leading-tight"
                  >
                    {section.title}
                    <div
                      style={{
                        WebkitTextStroke: "0px white",
                        fontSize: 'clamp(14px, 1.2vw + 0.8vh, 24px)',
                      }}
                      className="font-bold text-zinc-500 leading-none"
                    >
                      <span className="group-hover:opacity-0 group-hover:-translate-x-8 inline-block duration-300">
                        {section.id}.
                      </span>
                      <span className="opacity-0 group-hover:opacity-100 group-hover:-translate-x-8 inline-block duration-300">
                        {section.category}
                      </span>
                    </div>
                  </h2>
                </div>
              </Link>

              {/* Add border after each section except the last one for mobile */}
              {index < caseStudyData.length - 1 && (
                <div className="border-t border-gray-700/15 xl:hidden"></div>
              )}
            </React.Fragment>
          ))}

          <div className="h-[0.5px] w-[100%] hidden xl:block dark:bg-zinc-200/30 bg-zinc-300 absolute xl:bottom-43 bottom-0 overflow-hidden">
            <div
              className="w-1/12 h-full dark:bg-white bg-black absolute"
              style={{
                left: `${lineX}%`,
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}
